import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  backgroundImage: belongsTo('asset', { inverse: null }),
  channels: hasMany('channel', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  embedService: belongsTo('category', { inverse: null }),
});
